import { addDoc, Timestamp, collection, getDocs, setDoc, doc, query, where } from "firebase/firestore";
import { db } from "./firebase";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import TopBar from "./header/navbar/TopBar";
import Footer from "./footer/Footer";
import { useState } from "react";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const MyDashboard = () => {
    const [WeeklyRewardWest, setWeeklyRewardWest] = useState(0)
    const [WeeklyRewardEast, setWeeklyRewardEast] = useState(0)
    const [WeeklyRewardNorth, setWeeklyRewardNorth] = useState(0)
    const [WeeklyRewardSouth, setWeeklyRewardSouth] = useState(0)
    const [firebaseData, setfirebaseData] = useState([])
    const [WalletAddress, setWalletAddress] = useState([]);
    const navigate = useNavigate()

    useEffect(() => {
        if (localStorage.WalletAddress == "QARNCG6OHZJGKYYIMU6UVJXRFN7FWDPCUS7VNTVDTMNGYJ3EB5LINJNFGI") {
            navigate("/dashboard")
        } else {
            navigate("/")
        }
    }, [])

    const handleFirebaseWest = async () => {
        await setDoc(doc(db, "RewardInfo", "West"), {
            West: WeeklyRewardWest,
        }).then(async (res) => {
            toast("West Zone Reward Added Succesfully")
            const q = query(collection(db, "stakeInfo"), where("zone", "==", "west"))
            const spanshot = await getDocs(q)
            spanshot.forEach(async (docss) => {
                console.log(docss.data());
                console.log(WeeklyRewardNorth);
                await setDoc(doc(db, "stakeInfo", docss.data().assetid.toString()), {
                    zoneReward: WeeklyRewardWest,
                }, { merge: true })
            })
        })
    }
    const handleFirebaseEast = async () => {
        await setDoc(doc(db, "RewardInfo", "East"), {
            East: WeeklyRewardEast,
        }).then(async (res) => {
            toast("East Zone Reward Added Succesfully")
            const q = query(collection(db, "stakeInfo"), where("zone", "==", "east"))
            const spanshot = await getDocs(q)
            spanshot.forEach(async (docss) => {
                await setDoc(doc(db, "stakeInfo", docss.data().assetid.toString()), {
                    zoneReward: WeeklyRewardEast,
                }, { merge: true })
            })
        })
    }
    const handleFirebaseNorth = async () => {
        await setDoc(doc(db, "RewardInfo", "North"), {
            North: WeeklyRewardNorth,
        }).then(async (res) => {
            toast("North Zone Reward Added Succesfully")
            const q = query(collection(db, "stakeInfo"), where("zone", "==", "north"))
            const spanshot = await getDocs(q)
            spanshot.forEach(async (docss) => {
                await setDoc(doc(db, "stakeInfo", docss.data().assetid.toString()), {
                    zoneReward: WeeklyRewardNorth,
                }, { merge: true })
            })
        })
    }

    const handleFirebaseSouth = async () => {
        await setDoc(doc(db, "RewardInfo", "South"), {
            South: WeeklyRewardSouth,
        }).then(async (res) => {
            toast("South Zone Reward Added Succesfully")
            const q = query(collection(db, "stakeInfo"), where("zone", "==", "south"))
            const spanshot = await getDocs(q)
            spanshot.forEach(async (docss) => {
                await setDoc(doc(db, "stakeInfo", docss.data().assetid.toString()), {
                    zoneReward: WeeklyRewardSouth,
                }, { merge: true })
            })
        })
    }
    const getFirebasedata = async () => {
        const q = query(collection(db, "RewardInfo"));
        const querySnapshot = await getDocs(q);
        var temp = {}
        querySnapshot.forEach((doc) => {
            temp[doc.id] = Object.values(doc.data())[0]
            if (doc.id == 'West') {
                setWeeklyRewardWest(doc.data().West)
            }
            if (doc.id == 'East') {
                setWeeklyRewardEast(doc.data().East)
            }
            if (doc.id == 'North') {
                setWeeklyRewardNorth(doc.data().North)
            }
            if (doc.id == 'South') {
                setWeeklyRewardSouth(doc.data().South)
            }
        });
        setfirebaseData(temp)
    }



    const WalletListner = () => {
        if (localStorage.WalletAddress) {
            setWalletAddress(localStorage.WalletAddress);
        }
    };


    useEffect(() => {
        WalletListner()

    }, [])


    useEffect(() => {
        console.log(WalletAddress);
    }, [WalletAddress])

    useEffect(() => {
        getFirebasedata()
    }, [])
    useEffect(() => {
        console.log(firebaseData);
    }, [firebaseData])
    return (



        <>
            <TopBar />
            <div className="dashboard container">
                <Tabs
                    defaultActiveKey="East"
                    id="uncontrolled-tab-example"
                    className="mb-3"

                >
                    <Tab eventKey="East" title="East">
                        <label className="label-for-reward">Enter Weekly East Reward</label>
                        <input className="myInput" type="number" value={WeeklyRewardEast} onChange={(e) => {
                            setWeeklyRewardEast(e.target.value)
                            console.log(e.target.value)
                        }} />
                        <button className="submit-btn" onClick={handleFirebaseEast}>Submit</button>
                    </Tab>
                    <Tab eventKey="West" title="West">
                        <label className="label-for-reward">Enter Weekly West Reward</label>
                        <input className="myInput" type="number" value={WeeklyRewardWest} onChange={(e) => {
                            setWeeklyRewardWest(e.target.value)
                            console.log(e.target.value)
                        }} />
                        <button className="submit-btn" onClick={handleFirebaseWest}>Submit</button>
                    </Tab>
                    <Tab eventKey="North" title="North" >
                        <label className="label-for-reward">Enter Weekly North Reward</label>
                        <input className="myInput" type="number" value={WeeklyRewardNorth} onChange={(e) => {
                            setWeeklyRewardNorth(e.target.value)
                            console.log(e.target.value)
                        }} />
                        <button className="submit-btn" onClick={handleFirebaseNorth}>Submit</button>
                    </Tab>
                    <Tab eventKey="South" title="South" >
                        <label className="label-for-reward">Enter Weekly South Reward</label>
                        <input className="myInput" type="number" value={WeeklyRewardSouth} onChange={(e) => {
                            setWeeklyRewardSouth(e.target.value)
                            console.log(e.target.value)
                        }} />
                        <button className="submit-btn" onClick={handleFirebaseSouth}>Submit</button>
                    </Tab>
                </Tabs>


            </div>
            <Footer />
        </>




    )
}
export default MyDashboard